// extracted by mini-css-extract-plugin
export default {"sso":"SSO_sso__uWeUg","sso-login-button":"SSO_sso-login-button__W6inV","sso-action":"SSO_sso-action__qqgUn"};